// dose-log.js — the single source of truth for the nurse's deliberate dose-logging
// grammar (contract §11b). Both the standalone Worklist screen (Worklist.jsx) and
// the ward board's inline worklist lane (WardBoard.jsx) import these so the outcome
// set, the reason menus and — critically — the FHIR write are byte-identical across
// the two surfaces. The two surfaces differ ONLY in presentation (Worklist uses the
// Calm-Clinical token set; WardBoard uses the theme-aware shadcn tokens); the write
// path lives here, once.
import { recordDoseTick } from '../../lib/ipd-live.js';

// The three exception outcomes offered beside the primary "Given" confirm.
export const HOLD_OUTCOMES = [
  { key: 'held', label: 'Hold', hi: 'रोकें' },
  { key: 'refused', label: 'Refused', hi: 'मना किया' },
  { key: 'unavailable', label: 'Unavailable', hi: 'उपलब्ध नहीं' },
];

// Per-outcome quick reason chips (tap-to-save).
export const HOLD_REASONS = {
  held: ['NBM', 'Pre-procedure', 'Doctor advised', 'Vitals concern'],
  refused: ['Patient refused', 'Nausea', 'Asleep'],
  unavailable: ['Out of stock', 'Pharmacy pending'],
};

export const OUTCOME_LABEL = { given: 'Given', held: 'Held', refused: 'Refused', unavailable: 'Unavailable' };

// The write — FHIR-direct as the logged-in user. The row's EXACT slotKey keys a
// scheduled dose so the due-engine marks THIS slot done (wave-1 lesson: never
// recompute the slotKey). A PRN give mints a distinct `dose:{id}:prn:{ISO}` key at
// tap time so each PRN administration is its own record. Fail loud — the caller
// keeps the panel open and shows the message on rejection; the tick is never lost.
export async function commitDoseTick(item, { outcome, reason, note, aiOrigin } = {}) {
  const o = item.order || {};
  const slotKey = item.prn ? `dose:${o.id}:prn:${new Date().toISOString()}` : item.slotKey;
  const trimmed = (note || '').trim();
  return recordDoseTick({
    order: o,
    encounterId: item.encounterId,
    patientId: item.patient && item.patient.id,
    slotKey,
    outcome,
    ...(reason ? { reason } : {}),
    ...(trimmed ? { note: trimmed } : {}),
    // AI-origin provenance (DEFERRED.md → AI-origin): when the dock's command agent
    // logs a dose from voice/text, the verbatim utterance rides as the sourceQuote so
    // the MedicationAdministration is auditable as AI-originated. Manual taps omit it.
    ...(aiOrigin ? { aiOrigin } : {}),
  });
}
